const checkIsSafari = () => {
  const ua = navigator?.userAgent?.toLowerCase() || ''
  return !!ua && ua.includes('safari') && !ua.includes('chrome') && !ua.includes('android')
}
export const IS_SAFARI = checkIsSafari()
